/**
 * Created by fers on 26.08.16.
 */
/* global global */

import areIntlLocalesSupported from 'intl-locales-supported';
import {addLocaleData} from 'react-intl';
import enLocaleData from 'react-intl/locale-data/en';
import csLocaleData from 'react-intl/locale-data/cs';
import deLocaleData from 'react-intl/locale-data/de';
import {getCountriesForLocale} from '../common/intl/messages/countries';
import * as myLocales from '../common/locales';
import {getLocale as getBasicLocale, setLocale as setBasicLocale} from './basicLocales';


if (global.Intl) {
    // Determine if the built-in `Intl` has the locale data we need.
    if (!areIntlLocalesSupported(myLocales.getLocalesMyAppSupports())) {
        // `Intl` exists, but it doesn't have the data we need, so load the
        // polyfill and patch the constructors we need with the polyfill's.
        let IntlPolyfill    = require('intl');
        Intl.NumberFormat   = IntlPolyfill.NumberFormat;
        Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
    }
} else {
    // No `Intl`, so use and load the polyfill.
    global.Intl = require('intl');
}

addLocaleData(enLocaleData);
addLocaleData(csLocaleData);
addLocaleData(deLocaleData);

export let getSupportedLocales = myLocales.getSupportedLocales;
export const getLocale = getBasicLocale;
export const setLocale = setBasicLocale;
export let getLocalesMyAppSupports = myLocales.getLocalesMyAppSupports;

export function getLocalizedCountryName(code) {
	let lang = getLocale();

    let countries = getCountriesForLocale(lang);
	if (countries[code]) {
		return countries[code]["name"];
	}
	return null;
}

export function getLocalizedCountries() {
	let lang = getLocale();
    return getCountriesForLocale(lang);
}
